type AddressParts = {
  street_address?: string | null;
  street_address_line_2?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  zipcode?: string | null;
};

export const formatAddressLines = (address?: AddressParts | null): string[] => {
  if (!address) return [];

  return [
    [address.street_address, address.street_address_line_2],
    [address.city, address.state],
    [address.country, address.zipcode],
  ]
    .map((parts) => parts.filter(Boolean).join(", "))
    .filter(Boolean);
};
